import React, { useEffect, useRef, useState } from "react";
import Input from "common/Inputs/Input.tsx";
import CloseOutlined from "@ant-design/icons/CloseOutlined";
import SearchOutlined from "@ant-design/icons/SearchOutlined";
import { HEADER_ICON_SIZE } from "@shared/common/Themes/constants.ts";
import { useTheme } from "styled-components";

export const useSelectSearch = () => {
  const theme = useTheme();
  const [isSearch, setIsSearch] = useState(false);
  const [searchValue, setSearchValue] = useState<string | undefined>();
  const inputRef = useRef<HTMLInputElement>();

  useEffect(() => {
    if (isSearch) {
      inputRef.current?.focus();
    }
  }, [isSearch]);

  const getSearchComponent = () => {
    if (isSearch) {
      return (
        <Input
          ref={inputRef}
          onChange={(e: any) => setSearchValue(e.target.value)}
          style={{ maxWidth: 200 }}
          suffix={
            <CloseOutlined
              style={{ color: theme.colors.secondaryText }}
              onClick={() => {
                setSearchValue("");
                setIsSearch(false);
              }}
            />
          }
        />
      );
    } else {
      return (
        <SearchOutlined
          style={{
            fontSize: HEADER_ICON_SIZE,
            color: theme.colors.secondaryText,
          }}
          onClick={() => setIsSearch(true)}
        />
      );
    }
  };

  return {
    isSearch,
    setIsSearch,
    searchValue,
    setSearchValue,
    searchComponent: getSearchComponent(),
  };
};
